const LogLevelPrefix = {
  "\u{1F47E} \u{1F525}": "\u{1F47E} \u{1F525}",
  "\u{1F47E} \u33D2": "\u{1F47E} \u33D2",
  "\u{1F47E} \u26A0\uFE0F": "\u{1F47E} \u26A0\uFE0F",
  "\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u{1F525}": "\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u{1F525}",
  "\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u33D2": "\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u33D2",
  "\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u26A0\uFE0F": "\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u26A0\uFE0F"
};
const getLoglevelPrefix = (logLevel) => {
  switch (logLevel) {
    case "error":
      return import.meta.server ? LogLevelPrefix["\u{1F47E} \u{1F525}"] : LogLevelPrefix["\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u{1F525}"];
    case "info":
      return import.meta.server ? LogLevelPrefix["\u{1F47E} \u33D2"] : LogLevelPrefix["\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u33D2"];
    case "warning":
      return import.meta.server ? LogLevelPrefix["\u{1F47E} \u26A0\uFE0F"] : LogLevelPrefix["\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u26A0\uFE0F"];
    default:
      return import.meta.server ? LogLevelPrefix["\u{1F47E} \u{1F525}"] : LogLevelPrefix["\u{1F468}\u{1F3FB}\u200D\u{1F4BB} \u{1F525}"];
  }
};
export const onErrorCallback = (event, { title, logLevel = "error", report, name, message, metadata }) => {
  const mode = import.meta.server ? "Server" : "Client";
  const errorClass = `${getLoglevelPrefix(logLevel)} ${mode} - ${name || ""}`;
  const errorMessage = message || report?.message || "";
  const groupingHash = `${logLevel} - ${mode} - ${name} - ${title}`;
  if (report) event.addMetadata("report", report);
  if (metadata && Object.keys(metadata).length) {
    Object.keys(metadata).forEach((key) => {
      event.addMetadata(key, metadata[key]);
    });
  }
  event.severity = logLevel;
  event.context = title;
  event.groupingHash = groupingHash;
  if (event.errors && event.errors[0]) {
    event.errors[0].errorClass = errorClass;
    event.errors[0].errorMessage = errorMessage;
  }
};
export function bugsnagLogger(logParams, client) {
  if (!client) return;
  const { whitelistedRedactedKeys } = logParams;
  const configuredRedactedKeys = client._config.redactedKeys;
  if (whitelistedRedactedKeys) {
    client._config.redactedKeys = configuredRedactedKeys.filter((key) => !whitelistedRedactedKeys.includes(key));
  }
  const error = logParams.error instanceof Error ? logParams.error : logParams.title || "Unknown Error from logParams";
  try {
    client.notify(error, (event) => onErrorCallback(event, logParams));
  } finally {
    client._config.redactedKeys = configuredRedactedKeys;
  }
}
